import { array, func } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import MoodBoardTag from '@features/trend-research/components/moodboard/components/MoodBoardTag';
import { useFetchMoodBoardTagsQuery } from '@features/trend-research/api/moodboardApi';

const MoodBoardTagsWrapper = ({ tagResponseList, callBack }) => {
	const tagRef = useRef(null);
	const { id } = useParams();
	const [isShowTags, setIsShowTags] = useState(false);
	const [productWiseTags, setProductWiseTags] = useState([]);
	const [search, setSearch] = useState('');
	let params = '?type=TREND_MOODBOARD_TAG';
	if (search) {
		params += `&search=${search}`;
	}
	const { data } = useFetchMoodBoardTagsQuery(params);

	useEffect(() => {
		if (data) {
			setProductWiseTags(data);
		}
	}, [data]);

	useEffect(() => {
		document.addEventListener('click', onOutSideClick);
		return () => {
			document.removeEventListener('click', onOutSideClick);
		};
	}, [isShowTags]);

	const onOutSideClick = (event) => {
		if (isShowTags && tagRef && !tagRef.current?.contains(event.target)) {
			setIsShowTags(false);
		}
	};
	const renderProductTags = () => {
		return tagResponseList?.map((item, index) => {
			return (
				<span
					key={`all_tags_${index}`}
					style={{ background: item.colorCode }}
					className="status radius"
				>
					{item.text}
				</span>
			);
		});
	};

	const updateTagList = async () => {
		await callBack();
	};

	return (
		<>
			<div className="d-flex justify-content-between my-2">
				<div>
					<div
						className="tags design-tags"
						onClick={(e) => {
							e.stopPropagation();
							setIsShowTags(true);
						}}
					>
						{renderProductTags()}
					</div>
				</div>
				<div className="add-tag ml-1">
					<button
						className="button text-only"
						onClick={(e) => {
							e.stopPropagation();
							setIsShowTags(true);
						}}
					>
						<img
							src={`${process.env.PUBLIC_URL}/icons/add_black_24dp.png`}
							width={16}
							alt="plus"
						/>{' '}
						<span className="gray_dark_03 regular-12">Add Tag</span>
					</button>
				</div>
			</div>
			{isShowTags && (
				<div ref={tagRef}>
					<MoodBoardTag
						currentProductTagList={tagResponseList}
						moodBoardId={parseInt(id)}
						allTagList={productWiseTags}
						fetchAllTags={(text) => setSearch(text)}
						updateTagList={updateTagList}
					/>
				</div>
			)}
		</>
	);
};

MoodBoardTagsWrapper.propTypes = {
	callBack: func.isRequired,
	tagResponseList: array.isRequired
};

export default MoodBoardTagsWrapper;
